import React  from 'react';
import { Dialog, DialogContent } from "@mui/material";
import { styled } from "@mui/system";
import { useRecoilValue, useResetRecoilState } from "recoil";
import ModalTitleCustom from "src/shared/components/modals/ModalTitle";
import { imageProfessionalState, showMoldalImageProfessionalState } from "./state/atoms";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const ModalShowPhoto = () => {

    const resetShowImageProfessional = useResetRecoilState(showMoldalImageProfessionalState);
    const showMoldalImageProfessional = useRecoilValue(showMoldalImageProfessionalState)
    const imageProfessional = useRecoilValue(imageProfessionalState);
    const resetImageProfessional = useResetRecoilState(imageProfessionalState);

    const handleClose = () => {
        resetShowImageProfessional()
        resetImageProfessional()
    }

    return (
        <BootstrapDialog
            fullWidth
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={showMoldalImageProfessional}
        >
            <ModalTitleCustom id="customized-dialog-title" onClose={handleClose}>
                {imageProfessional?.alt}
            </ModalTitleCustom>
            <DialogContent style={{ paddingTop: 16, display: 'flex', justifyContent: 'center' }}>
                <img 
                    style={{ width: '100%' }}
                    src={imageProfessional?.image.replace("dpr_1.0", "dpr_2.0")}
                    alt={imageProfessional?.alt}
                />
            </DialogContent>
        </BootstrapDialog>
    );
};

export default ModalShowPhoto;
